export default {
	title: 'Terms',
}
